export class ItensPedido
{
    public produtoId: string;
    public produto: any;
    public codProduto: string;
    public descricao: string;
    public quantidade: number;
    public data:Date;
    public vrUnitario: number
    public tipoProduto: string;
    public qtdePorCaixa: number;
    
    public get vrTotal(): number
    {
        var rt : number = 0;
        if (this.quantidade && this.vrUnitario)
        {
            rt = Number(this.quantidade * this.vrUnitario);
        }
        return rt;
    }

    public Assing(item)
    {
        this.produtoId = item.produtoId;
        this.produto = item.produto;
        this.codProduto = item.codProduto;
        this.descricao = item.descricao;
        this.quantidade = item.quantidade;
        this.data = item.data;
        this.vrUnitario = item.vrUnitario;
        this.qtdePorCaixa = item.qtdePorCaixa;
    }

    

}
